module.exports = __webpack_public_path__ + "static/media/paper-clip.61bca916.svg";